import type { IReportType } from '../types/report';

import { deepCopy } from '../../../utils/deepCopy';
import { create } from 'zustand';

export interface IReportCacheValue {
  requestId?: string;
  data?: IReportType;
}
export type IReportDataCache = Record<string, IReportCacheValue>;

export interface IReportStoreState {
  cacheData: IReportDataCache;
  upsertCacheData: (key: string, value: IReportCacheValue) => void;
  getCacheData: () => IReportDataCache;
}
export const useReportStore = create<IReportStoreState>()((set, get) => ({
  cacheData: {},
  upsertCacheData: (key, value) => {
    const currentCacheData = deepCopy(get().cacheData);
    const updatedCacheData = {
      ...currentCacheData,
      [key]: {
        requestId: currentCacheData[key]?.requestId ?? '',
        ...value,
      },
    };

    set({ cacheData: updatedCacheData });
  },
  getCacheData: () => get().cacheData,
}));
